/* Brunelia, fiche produit A (19/10/2026) : galerie « de près et chez vous », scène « Voyez-la chez vous », pack intelligent.
   Chargé en defer par sections/rv-product-main.liquid. Tout reste lisible sans script (la scène garde son dessin de départ). */
(function () {
  "use strict";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  var pdp = $("[data-rv-pdp]");
  var money = function (c) { return window.RV && RV.money ? RV.money(c) : (Number(c) / 100).toFixed(2); };

  /* ---------- Galerie : un clic ouvre le zoom plein écran existant (rv-lot2.js) sur la bonne photo ----------
     data-rva-open = 0 pour l'affiche (et ses détails), n pour la n-ième mise en situation (même ordre que les vignettes du haut). */
  document.addEventListener("click", function (e) {
    var f = e.target.closest && e.target.closest("[data-rva-open]"); if (!f) return;
    var n = Number(f.getAttribute("data-rva-open")) || 0;
    var th = n > 0 ? $$('.gal-thumbs button[data-view="photo"]')[n - 1] : $('.gal-thumbs button[data-view="wall"]');
    if (th) th.click();
    setTimeout(function () {
      var gal = $("[data-rv-gal]"); if (!gal) return;
      var im = gal.querySelector("img.ph-full") || gal.querySelector("[data-rv-gal-frame] img");
      if (im) im.click();
    }, 30);
  });
  /* ---------- Gros plans décrits : un clic ouvre SEULEMENT la partie du dessin, en haute définition (recadrage du fichier d'impression) ----------
     Flèches, clavier (← → Échap), glisser au doigt ; légende précise sous l'image. */
  var gps = $$("[data-rva-gp]");
  if (gps.length) {
    var lb = document.createElement("div"), lbI, lbP, idx = 0, last = null;
    lb.className = "rva-lb"; lb.hidden = true; lb.setAttribute("role", "dialog"); lb.setAttribute("aria-modal", "true"); lb.setAttribute("aria-label", RV.t("fiche_a_js.lb_label"));
    lb.innerHTML = '<img alt=""><p></p><button type="button" class="x" aria-label="' + RV.t("core_js.close") + '">×</button>' +
      (gps.length > 1 ? '<button type="button" class="pv" aria-label="' + RV.t("fiche_a_js.prev") + '">‹</button><button type="button" class="nx" aria-label="' + RV.t("fiche_a_js.next") + '">›</button>' : "");
    document.body.appendChild(lb); lbI = $("img", lb); lbP = $("p", lb);
    var show = function (i) {
      idx = (i + gps.length) % gps.length; var f = gps[idx], cap = f.getAttribute("data-cap") || "";
      lbI.src = f.getAttribute("data-hd"); lbI.alt = cap;
      lbP.innerHTML = ""; lbP.appendChild(document.createTextNode(cap));
      var sm = document.createElement("small"); sm.textContent = RV.t("fiche_a_js.closeup_n", { i: idx + 1, n: gps.length }); lbP.appendChild(sm);
    };
    var open = function (i) { last = document.activeElement; show(i); lb.hidden = false; document.documentElement.style.overflow = "hidden"; $(".x", lb).focus(); };
    var close = function () { lb.hidden = true; document.documentElement.style.overflow = ""; if (last && last.focus) last.focus(); };
    gps.forEach(function (f, i) {
      f.setAttribute("aria-label", RV.t("fiche_a_js.enlarge", { cap: f.getAttribute("data-cap") || "" }));
      f.addEventListener("click", function () { open(i); });
    });
    $$("[data-rva-gp-open]").forEach(function (b) { b.addEventListener("click", function () { open(Number(b.getAttribute("data-rva-gp-open")) || 0); }); });
    lb.addEventListener("click", function (e) {
      if (e.target.closest(".x") || e.target === lb) close();
      else if (e.target.closest(".pv")) show(idx - 1);
      else if (e.target.closest(".nx")) show(idx + 1);
    });
    document.addEventListener("keydown", function (e) {
      if (lb.hidden) return;
      if (e.key === "Escape") close(); else if (e.key === "ArrowLeft") show(idx - 1); else if (e.key === "ArrowRight") show(idx + 1);
      else if (e.key === "Tab") { var bs = $$("button", lb), k = bs.indexOf(document.activeElement); e.preventDefault(); bs[(k + (e.shiftKey ? -1 : 1) + bs.length) % bs.length].focus(); }
    });
    var tx = null;
    lb.addEventListener("touchstart", function (e) { tx = e.touches.length === 1 ? e.touches[0].clientX : null; }, { passive: true });
    lb.addEventListener("touchend", function (e) { if (tx === null) return; var d = e.changedTouches[0].clientX - tx; if (Math.abs(d) > 50) show(idx + (d < 0 ? 1 : -1)); tx = null; });
  }

  /* ---------- « Voyez-la chez vous » ----------
     Unités : centimètres, sol en y = 0, vers le haut = y négatif. Commode 100 x 82 cm, affiche accrochée 20 cm au-dessus,
     silhouette de 1,75 m (50 cm de large) 40 cm à droite du bloc commode + affiche.
     Le cadrage (viewBox) est calculé une seule fois à partir du PLUS GRAND format de la fiche, dans le sens réel de l'affiche :
     hauteur = max(silhouette, commode + 20 + hauteur de la plus grande affiche) + 22 cm au-dessus ; largeur = max(commode, plus
     large affiche) + 40 + 50 + 2 x 20 cm de marge. La boîte est ensuite élargie au rapport 4/3 de la scène (sol toujours en bas).
     Tous les formats tiennent donc entièrement dans la scène, avec de la marge, à la même échelle réelle. */
  var sc = $("[data-rva-scale]");
  if (sc && pdp) scale(sc);

  function scale(sc) {
    var BW = 100, BH = 82, HANG = 20, MW = 50, MH = 175, GAP = 40, M = 20, HEAD = 22, FLOOR = 8, R = 4 / 3;
    var land = sc.getAttribute("data-land") === "1";
    var svg = $("svg", sc), stage = $("[data-rva-stage]", sc), now = $("[data-rva-now]", sc);
    var post = $("[data-rva-post]", sc), edge = $("[data-rva-edge]", sc), shadow = $("[data-rva-shadow]", sc);
    var bench = $("[data-rva-bench]", sc), who = $("[data-rva-who]", sc), floor = $("[data-rva-floor]", sc);
    var tiles = $$(".rva-tiles [role=radio]", sc);
    function radios() { return $$("form input[name=id][data-w]", pdp).filter(function (r) { return Number(r.getAttribute("data-w")) > 0; }); }
    function dims(r) { var w = Number(r.getAttribute("data-w")), h = Number(r.getAttribute("data-h")); if ((land && h > w) || (!land && w > h)) { var t = w; w = h; h = t; } return [w, h]; }
    var rs = radios(); if (!rs.length) { sc.hidden = true; return; }
    var maxW = 0, maxH = 0;
    rs.forEach(function (r) { var d = dims(r); maxW = Math.max(maxW, d[0]); maxH = Math.max(maxH, d[1]); });
    var blockW = Math.max(BW, maxW), CX = blockW / 2;
    var top = Math.max(MH, BH + HANG + maxH) + HEAD;
    var needW = blockW + GAP + MW + 2 * M, needH = top + FLOOR;
    var vbW = needW, vbH = needH, x0 = -M, y0 = -top;
    if (needW / needH < R) { vbW = needH * R; x0 = -M - (vbW - needW) / 2; } else { vbH = needW / R; y0 = FLOOR - vbH; }
    svg.setAttribute("viewBox", [x0, y0, vbW, vbH].map(function (n) { return n.toFixed(2); }).join(" "));
    floor.setAttribute("x", x0.toFixed(2)); floor.setAttribute("width", vbW.toFixed(2)); floor.setAttribute("height", FLOOR);
    bench.setAttribute("transform", "translate(" + (CX - BW / 2).toFixed(2) + " 0)");
    who.setAttribute("transform", "translate(" + (blockW + GAP).toFixed(2) + " 0)");

    /* l'image n'est demandée que quand la scène approche de l'écran */
    var src = sc.getAttribute("data-img");
    function loadImg() { if (src) { post.setAttribute("href", src); src = ""; } }
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (es) { if (es.some(function (x) { return x.isIntersecting; })) { loadImg(); io.disconnect(); } }, { rootMargin: "400px" });
      io.observe(sc);
    } else loadImg();

    var cur = null, anim = 0;
    function place(g) {
      [[post, 0], [edge, 0], [shadow, 1]].forEach(function (p) {
        var el = p[0], o = p[1];
        el.setAttribute("x", (g.x + o).toFixed(2)); el.setAttribute("y", (g.y + o).toFixed(2));
        el.setAttribute("width", g.w.toFixed(2)); el.setAttribute("height", g.h.toFixed(2));
      });
    }
    function geo(r) { var d = dims(r); return { x: CX - d[0] / 2, y: -(BH + HANG + d[1]), w: d[0], h: d[1] }; }
    function checked() { var all = radios(); return all.filter(function (r) { return r.checked; })[0] || all[0]; }
    function draw(instant) {
      var r = checked(), g = geo(r), k = r.getAttribute("data-k") || "";
      var from = cur; cur = g;
      cancelAnimationFrame(anim);
      if (!from || instant || reduce) place(g);
      else {
        var t0 = performance.now(), D = 320;
        var step = function (t) {
          var p = Math.min(1, (t - t0) / D), e = 1 - Math.pow(1 - p, 3);
          place({ x: from.x + (g.x - from.x) * e, y: from.y + (g.y - from.y) * e, w: from.w + (g.w - from.w) * e, h: from.h + (g.h - from.h) * e });
          if (p < 1) anim = requestAnimationFrame(step);
        };
        anim = requestAnimationFrame(step);
      }
      var tile = tiles.filter(function (b) { return b.getAttribute("data-k") === k; })[0];
      tiles.forEach(function (b) { var on = b === tile; b.setAttribute("aria-checked", String(on)); b.tabIndex = on ? 0 : -1; });
      var d = r.getAttribute("data-dims") || "";
      if (now) { nowLock(); var nh = nowHTML(r); if (now.innerHTML !== nh) now.innerHTML = nh; }
      stage.setAttribute("aria-label", RV.t("fiche_a_js.stage", { f: k || "", dims: d ? " (" + d + ")" : "" }));
    }
    /* the line under the tiles keeps the height of its longest version (all formats measured at this width):
       a format change swaps the words without moving the scene under it */
    function nowHTML(r) {
      var k = r.getAttribute("data-k") || "", d = r.getAttribute("data-dims") || "";
      var tile = tiles.filter(function (b) { return b.getAttribute("data-k") === k; })[0], use = tile ? tile.getAttribute("data-use") : "";
      return "<b>" + esc(k || r.getAttribute("data-fmt")) + "</b>" + (d ? " · " + esc(d) : "") + (use ? ' · <span class="u">' + esc(use) + "</span>" : "") + ' · <span class="rva-pr">' + money(r.getAttribute("data-price")) + "</span>";
    }
    var nowW = -1;
    function nowLock() {
      var w = now.clientWidth; if (!w || w === nowW) return; nowW = w;
      var keep = now.innerHTML, max = 0; now.style.minHeight = "";
      radios().forEach(function (x) { now.innerHTML = nowHTML(x); max = Math.max(max, now.getBoundingClientRect().height); });
      now.innerHTML = keep; now.style.minHeight = max ? Math.ceil(max) + "px" : "";
    }
    window.addEventListener("resize", function () { if (now && now.clientWidth !== nowW) { nowLock(); } });
    function esc(s) { return String(s || "").replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
    function pick(k, focus) {
      var r = checked(), o2 = r ? r.getAttribute("data-o2") : "";
      var c = radios().filter(function (x) { return x.getAttribute("data-k") === k; });
      var t = c.filter(function (x) { return x.getAttribute("data-o2") === o2; })[0] || c[0]; if (!t) return;
      if (!t.checked) { t.checked = true; t.dispatchEvent(new Event("change", { bubbles: true })); }
      draw();
      if (focus) { var b = tiles.filter(function (x) { return x.getAttribute("data-k") === k; })[0]; if (b) b.focus(); }
    }
    tiles.forEach(function (b) { b.addEventListener("click", function () { pick(b.getAttribute("data-k")); }); });
    $(".rva-tiles", sc).addEventListener("keydown", function (e) {
      var i = tiles.indexOf(document.activeElement); if (i < 0) return;
      var n = e.key === "ArrowRight" || e.key === "ArrowDown" ? 1 : e.key === "ArrowLeft" || e.key === "ArrowUp" ? -1 : 0; if (!n) return;
      e.preventDefault(); pick(tiles[(i + n + tiles.length) % tiles.length].getAttribute("data-k"), true);
    });
    pdp.addEventListener("change", function (e) { if (e.target && e.target.name === "id") draw(); });
    document.addEventListener("change", function (e) { if (e.target && e.target.matches && e.target.matches("[data-rv-satc-sel]")) setTimeout(draw, 0); });
    document.addEventListener("click", function (e) { if (e.target.closest && e.target.closest("[data-rv-sv]")) setTimeout(draw, 0); });
    window.addEventListener("pageshow", function () { draw(true); });
    draw(true);
  }

  /* ---------- Pack intelligent (seulement si le réglage du thème « packs_actifs » est allumé : sinon le bloc n'existe pas) ---------- */
  $$("[data-rva-pack]").forEach(function (pk) {
    var data; try { data = JSON.parse($("script[type='application/json']", pk).textContent); } catch (e) { return; }
    var seg = $$("[data-pf]", pk), btn = $("[data-rva-pack-add]", pk), fmt = data.def;
    function render() {
      var items = data.items.map(function (it) { return it.v[fmt]; });
      var ok = items.every(function (x) { return x && x.a; });
      var sum = items.reduce(function (s, x) { return s + (x ? x.p : 0); }, 0);
      var n = items.length, pct = n >= 4 ? data.r4 : n >= 3 ? data.r3 : 0, after = Math.round(sum * (100 - pct) / 100);
      seg.forEach(function (b) { b.setAttribute("aria-pressed", String(b.getAttribute("data-pf") === fmt)); });
      $$("[data-rva-unit]", pk).forEach(function (u, i) { var x = items[i]; u.textContent = fmt + " · " + (x ? money(x.p) : "–"); });
      $("[data-rva-sum]", pk).textContent = money(sum);
      $("[data-rva-total]", pk).textContent = money(after);
      $("[data-rva-pct]", pk).textContent = RV.t("core_js.pct_off", { pct: pct });
      btn.disabled = !ok;
    }
    seg.forEach(function (b) { b.addEventListener("click", function () { fmt = b.getAttribute("data-pf"); render(); }); });
    btn.addEventListener("click", function () {
      if (!window.RV || !RV.cart) return;
      var items = data.items.map(function (it) { return { id: it.v[fmt].id, quantity: 1, properties: { _pack: data.name + " (" + fmt + ")" } }; });
      btn.disabled = true;
      RV.cart.add(items).then(function () { RV.toast(RV.t("fiche_a_js.pack_added", { n: items.length, f: fmt })); }).catch(function () {}).then(function () { btn.disabled = false; });
    });
    render();
  });
})();
